import { render, staticRenderFns } from "./society.vue?vue&type=template&id=b2ae3b84&scoped=true"
import script from "./society.vue?vue&type=script&lang=js"
export * from "./society.vue?vue&type=script&lang=js"
import style1 from "./society.vue?vue&type=style&index=1&id=b2ae3b84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ae3b84",
  null
  
)

export default component.exports